module.exports = __webpack_public_path__ + "494cd07c/img/pdf-icon.79f04a36.svg";